import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import Order from 'src/smoothr-web-app-core/models/Order';
import moment from 'moment';
import { NavigationService } from 'src/app/services/navigation.service';
import { OrderUtils } from 'src/smoothr-web-app-core/utils/order-utils';
import { numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';

@Component({
	selector: 'app-app-header-menu',
	templateUrl: './app-header-menu.component.html',
	styleUrls: ['./app-header-menu.component.scss'],
})
export class AppHeaderMenuComponent {
	@Input()
	isBack: boolean = false;
	@Input()
	title: string = '';
	@Input()
	src: string;
	@Output() back = new EventEmitter<void>();
	@Input() customer: Customer;
	@Input() venue: Venue;
	@Input() order: Order;
	@Input() showGoToBasketBtn = false;
	@Output() showBasket = new EventEmitter<void>();
	public isOpen = false;
	public todayDate = moment();
	public listCountries = [
		{
			name: 'German',
			icon: '../../../assets/dean_and_david/lang/de.svg',
			value: 'de',
		},
		{
			name: 'English',
			icon: '../../../assets/dean_and_david/lang/gb.svg',
			value: 'en',
		},

		{
			name: 'Italy',
			icon: '../../../assets/dean_and_david/lang/cs.svg',
			value: 'cr',
		},
	];
	constructor(
		private popover: PopoverController,
		public translate: TranslateService,
		private navService: NavigationService,
		private repository: RepositoryService
	) {}

	ngOnInit() {}
	goBack() {
		this.back.emit();
	}
	get price(): number {
		if (!this.order) {
			return 0;
		}
		return OrderUtils.orderTotalPrice(this.order, true, true, this.repository.companyCode$.getValue() ?? null);
	}

	get formattedPrice(): string {
		return numberToCurrency(this.price, this.order.currency);
	}
	findFlag() {
		return this.listCountries.find(opt => opt.value === this.translate.currentLang).icon;
	}
	navToLogin() {
		this.navService.signIn();
	}
	myPorfile() {
		this.navService.account();
	}
	async openPopoverSelectionLanguage(event: Event) {
		// Language selection popover - placeholder for future implementation
		console.log('Language selection clicked', event);
	}
}
